import HomePage from "../Pages/HomePage";
import EditPage from "../Pages/EditPage";
import CreatePage from "../Pages/CreatePage";
import UploadPage from "../Pages/UploadPage";
import Brands from "../Pages/Brands";
import Retailers from "../Pages/Retailers";
import ImportData from "../Pages/ImportData";
import Profile from "../Pages/Profile";
import Verifications from "../Pages/Verifications";
import Verification from "../Pages/Verification";
import Queues from "../Pages/Queues";
import Queue from "../Pages/Queue";
import Management from "../Pages/Management";
import Analytics from "../Pages/Analytics";
import DataPipeline from "../Pages/DataPipeline";
import InvitePage from "../Pages/InvitePage";
import PlanRequests from "../Pages/PlanRequests";
import PittiInvite from "../Pages/PittiInvite";
import InviteUsers from "../Pages/InviteUsers";
import AdminUsers from "../Pages/AdminUsers";
import OrganizationEngagements from "../Pages/OrganizationEngagements";
import SalesAgentDetail from "../Pages/SalesAgentDetail";
import OrganizationDetail from "../Pages/OrganizationDetail";
import FairOrganizationDetail from "../Pages/FairOrganizationDetail";
import TrainAI from "../Pages/TrainAI";
import TrainVionne from "../Pages/TrainVionne";
import BrandRequests from "../Pages/BrandRequests/BrandRequests";
import CreateBrandRequest from "../Pages/BrandRequests/CreateBrandRequest";
import BrandRequestDetails from "../Pages/BrandRequests/BrandRequestDetails";
import DiscountCoupons from "../Pages/DiscountCoupons";
import SeasonalPassLinks from "../Pages/SeasonalPassLinks";
import WebsiteLeads from "../Pages/WebsiteLeads";

export const routes = [
  { path: "/home", element: <HomePage /> },
  { path: "/create", element: <CreatePage /> },
  { path: "/company/:id/edit", element: <EditPage /> },
  { path: "/company/:id/upload-data", element: <UploadPage /> },
  { path: "/brands", element: <Brands /> },
  { path: "/retailers", element: <Retailers /> },
  { path: "/import-data/:type", element: <ImportData /> },
  { path: "/profile/:id/:type", element: <Profile /> },
  { path: "/update-verifications", element: <Verifications /> },
  { path: "/verify-update", element: <Verification /> },
  { path: "/queues", element: <Queues /> },
  { path: "/queue", element: <Queue /> },
  { path: "/dashboard", element: <Analytics /> },
  { path: "/data-pipeline", element: <DataPipeline /> },
  { path: "/management", element: <Management /> },
  { path: "/invite", element: <InvitePage /> },
  { path: "/plan-requests", element: <PlanRequests /> },
  { path: "/pitti-invite", element: <PittiInvite /> },
  { path: "/invite-user", element: <InviteUsers /> },
  { path: "/admin-users", element: <AdminUsers /> },
  {
    path: "/organization-engagements/:organizationId",
    element: <OrganizationEngagements />,
  },
  {
    path: "/sales-agent/:organizationId",
    element: <SalesAgentDetail />,
  },
  {
    path: "/organization/:organizationId",
    element: <OrganizationDetail />,
  },
  {
    path: "/fair-organization/:organizationId",
    element: <FairOrganizationDetail />,
  },
  { path: "/ai-knowledge-base", element: <TrainAI /> },
  { path: "/train-vionne", element: <TrainVionne /> },
  { path: "/brand-requests", element: <BrandRequests /> },
  { path: "/brand-requests/create", element: <CreateBrandRequest /> },
  { path: "/brand-requests/:id", element: <BrandRequestDetails /> },
  { path: "/discount-coupons", element: <DiscountCoupons /> },
  { path: "/seasonal-pass-links", element: <SeasonalPassLinks /> },
  { path: "/website-leads", element: <WebsiteLeads /> },
];
